import { Application } from "@hotwired/stimulus"
import "@lottiefiles/lottie-player"
import ScrollController from "./application/controllers/scroll-controller"
import AnimatedHeadlineController from "./application/controllers/animated-headline-controller"
import WidgetExampleController from "./application/controllers/widget-example-controller"
import CodeHighlightController from "./application/controllers/code-highlight-controller"
import Wallets3dSceneController from "./application/controllers/wallets-3d-scene-controller"
import ConversionSceneController from "./application/controllers/conversion-scene-controller"
import WalletsRevolutionSceneController from "./application/controllers/wallets-revolution-scene-controller"
import NewsletterSubscriptionController from "./application/controllers/newsletter-subscription-controller"
import ZoomImageController from "./application/controllers/zoom-image-controller"
import YoutubePopupController from "./application/controllers/youtube-popup-controller"
import ClaimNFTController from "./application/controllers/claim-nft-controller"
import TokenSearchController from "./application/controllers/token-search-controller"
import BuyDePayController from "./application/controllers/buy-depay-controller"
import NavbarController from "./application/controllers/navbar-controller"
import FooterCollapsibleController from "./application/controllers/footer-collapsible-controller"

window.Stimulus = Application.start()
Stimulus.register("scroll", ScrollController)
Stimulus.register("animated-headline", AnimatedHeadlineController)
Stimulus.register("widget-example", WidgetExampleController)
Stimulus.register("code-highlight", CodeHighlightController)
Stimulus.register("wallets-3d-scene", Wallets3dSceneController)
Stimulus.register("conversion-scene", ConversionSceneController)
Stimulus.register("wallets-revolution-scene", WalletsRevolutionSceneController)
Stimulus.register("newsletter-subscription", NewsletterSubscriptionController)
Stimulus.register("zoom-image", ZoomImageController)
Stimulus.register("youtube-popup", YoutubePopupController)
Stimulus.register("claim-nft", ClaimNFTController)
Stimulus.register("token-search", TokenSearchController)
Stimulus.register("buy-depay", BuyDePayController)
Stimulus.register("navbar", NavbarController)
Stimulus.register("footer-collapsible", FooterCollapsibleController)
